import { z } from 'zod';

const handlebarRegex = /{{([^{}]*)}}/g;
const REQUIRED_STRING_FIELD = z.string().trim().nonempty({
  message: 'Required before sending campaign',
});
const REQUIRED_EMAIL_FIELD = z.string().email().nonempty();
const REQUIRED_EMAIL_WITH_HANDLEBAR_FIELD = REQUIRED_EMAIL_FIELD.or(
  z.string().regex(handlebarRegex),
);
const OPTIONAL_STRING_FIELD = z.string().optional();
const OPTIONAL_NULLABLE_STRING_FIELD = OPTIONAL_STRING_FIELD.nullable();
const OPTIONAL_URL_FIELD = z.union([z.literal(''), z.string().trim().url()]);
const OPTIONAL_NULLABLE_URL_FIELD = OPTIONAL_URL_FIELD.nullable();
const OPTIONAL_SECURE_URL_FIELD = z.union([
  z.literal(''),
  z.string().startsWith('https://', { message: 'Must provide a secure URL' }),
]);
const OPTIONAL_NULLABLE_SECURE_URL_FIELD = OPTIONAL_SECURE_URL_FIELD.nullable();

/**
 * Email template content related fields
 */
export const emailSubjectLineSchema = REQUIRED_STRING_FIELD;
export const emailPreheaderTextSchema = OPTIONAL_STRING_FIELD;
export const emailFromNameSchema = OPTIONAL_STRING_FIELD;
export const emailSendersEmailSchema = REQUIRED_EMAIL_WITH_HANDLEBAR_FIELD;
export const emailReplyToSchema = OPTIONAL_NULLABLE_STRING_FIELD;

/**
 * Push template content related fields
 */
export const pushTitleSchema = OPTIONAL_NULLABLE_STRING_FIELD;
export const pushMessageSchema = REQUIRED_STRING_FIELD;

/**
 * SMS template content related fields
 */
export const smsMessageSchema = OPTIONAL_STRING_FIELD;
export const smsImageUrlSchema = OPTIONAL_NULLABLE_URL_FIELD;

/**
 * Web push template content related fields
 */
export const webPushTitleSchema = OPTIONAL_NULLABLE_STRING_FIELD;
export const webPushBodySchema = OPTIONAL_STRING_FIELD;
export const webPushIconSchema = OPTIONAL_NULLABLE_URL_FIELD;
export const webPushClickLocationSchema = OPTIONAL_NULLABLE_SECURE_URL_FIELD;
// Either the title or the message is always required for a web push template
// So, adding a refinement to validate that either or, of the fields are not empty
export const webPushTitleOrBodyRefinement = (
  data: Record<string, any>,
  titleFieldName: string,
  bodyFieldName: string,
) => {
  const hasTitle = data[titleFieldName] !== '' && data[titleFieldName] !== null;
  const hasBody = data[bodyFieldName] !== '' && data[bodyFieldName] !== null;
  return hasTitle || hasBody;
};
